export const GetBaseUrl = (): string => (document.domain === 'localhost' ? process.env.VUE_APP_BASE_URL : `${window.location.protocol}//${document.domain}`);

export const getMaxScale = (maxNum) => {
  let dR = 5;
  if (maxNum > 50) dR = 10;
  if (maxNum > 100) dR = 50;
  if (maxNum > 500) dR = 100;
  if (maxNum > 1000) dR = 500;
  return (Math.ceil(maxNum / dR)) * dR;
};

export const getCookieValue = (key): string | null => {
  const cookieValueArray = document.cookie.match(`(^|[^;]+)\\s*${key}\\s*=\\s*([^;]+)`);
  if (cookieValueArray) {
    const cookieValue = cookieValueArray.pop();
    if (cookieValue) return cookieValue;
  }
  return null;
};

export const deleteCookie = (key) => {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

export const deleteAllCookie = () => {
  deleteCookie('accessToken');
  deleteCookie('idToken');
  deleteCookie('refreshToken');
  deleteCookie('defaultTab');
};

/**
 * 日付文字列を YYYY-MM-DD HH:mm 形式から YYYYMMDDHHMM 形式に変換
 * @param dateTimeString - 変換する日付文字列（例: "2025-09-04 01:40"）
 * @returns YYYYMMDDHHMM形式の文字列（例: "202509040140"）
 */
export const formatDateTimeToYYYYMMDDHHMM = (dateTimeString: string): string => {
  // 日付文字列をパースして各部分を取得
  const [datePart, timePart] = dateTimeString.split(' ');
  const [year, month, day] = datePart.split('-');
  const [hour, minute] = timePart.split(':');

  // YYYYMMDDHHMM形式で結合
  return `${year}${month}${day}${hour}${minute}`;
};
